import {
  CategoryNavigationMenu,
  CategoryNavigationMenuPath,
  GlobalNavigationMenu,
} from '@diritto/common/navigation/constant';
import { LocalStorageKey } from '@diritto/common/utils/localStorage';
import { GlobalNavigationMenuHref } from 'constants/navigation';
import { LocalStorage } from 'utils/LocalStorage';

export const getDynamicGlobalNavHref = (globalNavMenu: GlobalNavigationMenu) => {
  if (globalNavMenu === GlobalNavigationMenu.Ranking) {
    const categoryNavMenu =
      (LocalStorage.getItem(LocalStorageKey.RankingCategoryNavMenu) as CategoryNavigationMenu) ??
      CategoryNavigationMenu.All;
    return `${GlobalNavigationMenuHref[GlobalNavigationMenu.Ranking]}/${CategoryNavigationMenuPath[categoryNavMenu]}`;
  }

  return GlobalNavigationMenuHref[globalNavMenu];
};
